import { useSelector } from 'react-redux';
import { Form, Row, Input, DatePicker, Col } from 'antd';
import { Button } from 'components';
import { Select } from 'antd/lib';
import {
  MONITOREOS_INTERNET,
  MONITOREOS_ESPECTACULARES,
  MONITOREOS_MEDIOS_IMPRESOS,
  MONITOREOS_VISITAS_VERIFICACION
} from 'constants/tipoMonitoreos';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { CONFIGURACION_SISTEMA } from 'constants/nombresCatalogos';
import { DATE_FORMAT_DATE_PICKER } from 'constants/dateFormat';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import './BuscadorDescarga.scss';
import { DOWNLOAD_TYPES } from 'constants/downloadTypes';

const tiposMonitoreos = [
  { idTipoMonitoreo: MONITOREOS_ESPECTACULARES, tipoMonitoreo: 'ESPECTACULARES' },
  { idTipoMonitoreo: MONITOREOS_MEDIOS_IMPRESOS, tipoMonitoreo: 'MEDIOS IMPRESOS' },
  { idTipoMonitoreo: MONITOREOS_INTERNET, tipoMonitoreo: 'INTERNET' },
  { idTipoMonitoreo: MONITOREOS_VISITAS_VERIFICACION, tipoMonitoreo: 'VISITAS EVENTOS Y CASAS' }
];

const TiposEstatus = [
  { estatusId: 0, estatusDescripcion: 'En Proceso' },
  { estatusId: 1, estatusDescripcion: 'Terminado' }
];

const tipoDescarga = [
  { idTipoDescarga: DOWNLOAD_TYPES.TESTIGOS.value, tipoDescarga: DOWNLOAD_TYPES.TESTIGOS.label },
  { idTipoDescarga: DOWNLOAD_TYPES.SABANAS.value, tipoDescarga: DOWNLOAD_TYPES.SABANAS.label },
  { idTipoDescarga: DOWNLOAD_TYPES.TODO.value, tipoDescarga: DOWNLOAD_TYPES.TODO.label },
  { idTipoDescarga: DOWNLOAD_TYPES.DINAMICOS.value, tipoDescarga: DOWNLOAD_TYPES.DINAMICOS.label }
];

export const BuscadorDescarga = ({ onSearch }) => {
  const [searchForm] = Form.useForm();
  const configuracionSistema = useSelector(selectCatalogByName(CONFIGURACION_SISTEMA));
  const fechaIniciOper =
    configuracionSistema.find((config) => config.parametro === 'FECHA_INICIO_OPERACIONES')?.valor ||
    null;
  const dateFormat = 'YYYYMMDD';
  const fechaHoy = new Date().toISOString().slice(0, 10);

  const validateDate = (_, dateValue) => {
    const { getFieldValue } = searchForm;
    const otherFieldValue = getFieldValue('fechaInicio'); // Compara las fechas
    if (otherFieldValue && dateValue.isBefore(otherFieldValue)) {
      return Promise.reject(Error('La fecha no puede ser anterior a la fecha inicial.'));
    }
    return Promise.resolve();
  };
  const handleSearchByFilters = async () => {
    try {
      const paramsTemp = await searchForm.validateFields();
      const params = { ...paramsTemp };
      onSearch(params);
    } catch (error) {
      /* empty */
    }
  };

  const handleClearFilters = () => {
    searchForm.resetFields();
    onSearch({});
  };

  return (
    <div className="buscador-descargas">
      <Form form={searchForm} layout="horizontal">
        <Row gutter={24}>
          <Col xs={4}>
            <span className="buscador-descargas-etiqueta">ID de Descarga</span>
            <Form.Item name="idDescarga">
              <Input placeholder="Filtra" allowClear type="number" />
            </Form.Item>
          </Col>
          <Col xs={4}>
            <span className="buscador-descargas-etiqueta">Tipo de monitoreo</span>
            <Form.Item name="tipoMonitoreo">
              <Select
                className="buscador-descargas-campo"
                placeholder="Filtra"
                allowClear
                options={tiposMonitoreos}
                fieldNames={{
                  value: 'idTipoMonitoreo',
                  label: 'tipoMonitoreo'
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={4}>
            <span className="buscador-descargas-etiqueta">Estatus</span>
            <Form.Item name="estatus">
              <Select
                className="buscador-descargas-campo"
                placeholder="Filtra"
                allowClear
                options={TiposEstatus}
                fieldNames={{
                  value: 'estatusId',
                  label: 'estatusDescripcion'
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={4}>
            <span className="buscador-descargas-etiqueta">Fecha:</span>
            <Form.Item name="fechaInicio" label="Desde:" className="buscador-descargas-etiqueta">
              <DatePicker
                placeholder="Fecha inicio"
                allowClear
                format={DATE_FORMAT_DATE_PICKER}
                minDate={dayjs(fechaIniciOper, dateFormat)}
                maxDate={dayjs(fechaHoy, dateFormat)}
              />
            </Form.Item>
          </Col>
          <Col xs={4}>
            <span className="buscador-descargas-etiqueta" />
            <Form.Item
              name="fechaFinal"
              label="Hasta:"
              className="buscador-descargas-etiqueta"
              labelAlign="left"
              rules={[
                {
                  validator: validateDate
                }
              ]}>
              <DatePicker
                placeholder="Fecha Final"
                allowClear
                format={DATE_FORMAT_DATE_PICKER}
                minDate={dayjs(fechaIniciOper, dateFormat)}
                maxDate={dayjs(fechaHoy, dateFormat)}
              />
            </Form.Item>
          </Col>
          <Col xs={4}>
            <span className="buscador-descargas-etiqueta">Tipo de descarga</span>
            <Form.Item name="tipoDescarga">
              <Select
                className="buscador-descargas-campo"
                placeholder="Filtra"
                allowClear
                options={tipoDescarga}
                fieldNames={{
                  value: 'idTipoDescarga',
                  label: 'tipoDescarga'
                }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className="buscador-descargas-acciones">
        <Button text="Limpiar" onClick={handleClearFilters} />
        <span style={{ width: '1em' }} />
        <Button text="Buscar" type="primary" onClick={handleSearchByFilters} />
      </div>
    </div>
  );
};

BuscadorDescarga.propTypes = {
  onSearch: PropTypes.func.isRequired
};
